<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="padding-top: 4vh; height: 100%; width: 90%; margin: auto">

    <div class="row">

      <div class="col-9">
        <div class="row">
          <div class="col">
            <div class="alertsHeader" (click)="changePendingAlerts()" [ngClass]="{'noSelected' : !this.pendingAlertsBool}">
              <h1 class="centerVert textXM">{{this.localiser.get("alerts.pending")}}</h1>
            </div>
          </div>
          <div class="col">
            <div class="alertsHeader" (click)="changeSolvedAlerts()" [ngClass]="{'noSelected' : !this.solvedAlertsBool}">
              <h1 class="centerVert textXM">{{this.localiser.get("alerts.solved")}}</h1>
            </div>
          </div>
        </div>
        <div class="row alertRow" *ngFor="let alert of alerts">
          <div class="alertRowHeader" [ngClass]="{'alertRowHeaderCon': alert.tipoDispositivo == 'Gateway',
                                                  'alertRowHeaderLum': alert.tipoDispositivo == 'Luminaire',
                                                  'alertRowHeaderSensor': alert.tipoDispositivo == 'Sensor'}">
            <span *ngIf="alert.tipoDispositivo == 'Gateway'" class="material-icons-outlined centerVert textL">memory</span>
            <span *ngIf="alert.tipoDispositivo == 'Luminaire'" class="material-icons-outlined centerVert textL">wb_iridescent</span>
            <span *ngIf="alert.tipoDispositivo == 'Sensor'" class="material-icons-outlined centerVert textL">sensors</span>
          </div>
          <div class="alertRowInfo" [ngClass]="{'alertRowInfoPending': alert.estado == 'Pending',
                                                'alertRowInfoSolved': alert.estado == 'Solved'}">
            <div class="col-10" style="padding: unset; padding-left: 2%;">
              <div class="row">
                <div class="col marginAuto">
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.type")}}: {{getTipoDispositivo(alert.tipoDispositivo)}}</h1>
                  </div>
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">ID: {{alert.idDispositivo}}</h1>
                  </div>
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.name")}}: {{alert.nombre}}</h1>
                  </div>
                </div>
                <div class="col marginAuto">
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.floorplan")}}: {{getPlano(alert.idPlano)}}</h1>
                  </div>
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.zone")}}: {{getZona(alert.idZona)}}</h1>
                  </div>
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.status")}}: {{getEstado(alert.estado)}}</h1>
                  </div>
                </div>
                <div class="col marginAuto">
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.lastAlert")}}: {{alert.timeLastComFinalII}}</h1>
                  </div>
                  <div class="row marginAuto">
                    <h1 class="textS" style="display: contents">{{this.localiser.get("alerts.firstAlert")}}: {{alert.timeLastComII}}</h1>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="alert.tipoDispositivo == 'Sensor'">
                <div class="col marginAuto" style="margin: auto">
                  <h1 style="display: contents; font-size: 1.1vw"><b>{{this.localiser.get("alerts.measure")}}: {{(alert.measureEquivalente).toFixed(2)}} {{getUnidadMedidaById(alert.idDispositivo)}}</b></h1>
                </div>


                <div class="col marginAuto" style="margin: auto">
                  <h1 style="display: contents; font-size: 1.1vw"><b>{{this.localiser.get("alerts.lowerThreshold")}}: {{alert.umbralValorBajo}} {{getUnidadMedidaById(alert.idDispositivo)}}</b></h1>
                </div>

                <div class="col marginAuto" style="margin: auto">
                  <h1 style="display: contents; font-size: 1.1vw"><b>{{this.localiser.get("alerts.upperThreshold")}}: {{alert.umbralValorAlto}} {{getUnidadMedidaById(alert.idDispositivo)}}</b></h1>
                </div>

              </div>
            </div>
            <div class="col-2" style="text-align: center">
              <span *ngIf="alert.estado == 'Pending'" (click)="changeAlertToSolved(alert.idAlertaFinal)"
                    class="material-icons-outlined centerVert textL" style="cursor: pointer">done</span>
              <span *ngIf="alert.estado == 'Solved'" (click)="changeAlertToPending(alert.idAlertaFinal)"
                    class="material-icons-outlined centerVert textL" style="cursor: pointer">close</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3" style="padding: inherit; right: 1%; position: fixed; width: 22%;">
        <mat-checkbox (change)="changeShowGateways($event)" style="width: 70%; margin-left: 10%; margin-top: 4%" checked="true">
          <h1 class="textS marginAuto" style="white-space: break-spaces">{{this.localiser.get("alerts.showGateways")}}</h1>
        </mat-checkbox>
        <mat-checkbox (change)="changeShowLuminaires($event)" style="width: 70%; margin-left: 10%; margin-top: 4%" checked="true">
          <h1 class="textS marginAuto" style="white-space: break-spaces">{{this.localiser.get("alerts.showLuminaries")}}</h1>
        </mat-checkbox>
        <mat-checkbox (change)="changeShowSensors($event)" style="width: 70%; margin-left: 10%; margin-top: 4%" checked="true">
          <h1 class="textS marginAuto" style="white-space: break-spaces">{{this.localiser.get("alerts.showSensors")}}</h1>
        </mat-checkbox>

        <div class="col">
          <mat-select (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected" [placeholder]="this.localiser.get('alerts.floorplan')" class="selectFilter textS">
            <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("alerts.all")}}</b></mat-option>
            <mat-option class="textS+" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
          </mat-select>
        </div>

        <div class="col">
          <mat-select (selectionChange)="selectZona($event)" [(ngModel)]="zonaSelected" [placeholder]="this.localiser.get('alerts.zone')" class="selectFilter textS">
            <mat-option class="textS+" [value]="'all'"><b>{{this.localiser.get("alerts.all")}}</b></mat-option>
            <mat-option class="textS+" *ngFor="let zona of zonas" [value]="zona">{{zona.nombre}}</mat-option>
          </mat-select>
        </div>

        <mat-checkbox id="newAlert" [(ngModel)]="newAlertCheck" (change)="setCheck($event)" style="width: 70%; margin-left: 10%; margin-top: 4%">
          <h1 class="textS marginAuto" style="white-space: break-spaces">{{this.localiser.get("alerts.emailNew")}}</h1>
        </mat-checkbox>

        <mat-checkbox id="closeAlert" [(ngModel)]="closeAlertCheck" (change)="setCheck($event)" style="width: 70%; margin-left: 10%; margin-top: 4%">
          <h1 class="textS marginAuto" style="white-space: break-spaces">{{this.localiser.get("alerts.emailSolved")}}</h1>
        </mat-checkbox>

        <div class="">
          <div class="row" style="width: 50%; margin: 5% auto">
            <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(-1)" class="material-icons-outlined textXM centerVert cursorPointer navigateBefore"
                    [ngClass]="{disabled: actualPage == 1}">
                navigate_before
              </span>
            </div>
            <div class="col" style="padding: 0">
              <input type="number" class="inputPagination textXM centerVert" [(ngModel)]="this.actualPage" (ngModelChange)="changePageByNumber($event)"
                     (change)="outInputChangePageByNumber($event)">
            </div>
            <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(1)" class="material-icons-outlined textXM centerVert cursorPointer navigateAfter"
                    [ngClass]="{disabled: isLastPage()}">
                navigate_next
              </span>
            </div>
          </div>
          <div>
            <mat-progress-spinner *ngIf="loadingAlerts" class="spinnerBar centerVert" mode="indeterminate" diameter="40"></mat-progress-spinner>
          </div>
        </div>

      </div>


    </div>


  </div>
</div>
